import { render } from "./step-card-oralb.vue?vue&type=template&id=72e59640&scoped=true"
import script from "./step-card-oralb.vue?vue&type=script&lang=js"
export * from "./step-card-oralb.vue?vue&type=script&lang=js"

import "./step-card-oralb.vue?vue&type=style&index=0&id=72e59640&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e59640"]])

export default __exports__